import { createAuthClient } from "better-auth/react";
import { magicLinkClient, organizationClient } from "better-auth/client/plugins";
import { passkeyClient } from "@better-auth/passkey/client";

export function createClient(baseURL: string) {
  return createAuthClient({
    baseURL,
    plugins: [passkeyClient(), magicLinkClient(), organizationClient()],
  });
}

export type AuthClient = ReturnType<typeof createClient>;
